module.exports = __webpack_public_path__ + "img/img_kiwoom_design1_m.94dae505.png";